exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".occupation-container {\n  border: 1px solid grey;\n  height: 22px; }\n\n.occupation-container .bars {\n  display: inline-block;\n  height: 20px;\n  margin-right: -1px; }\n\n.occupation-container .filled {\n  background-color: green;\n  margin-left: 0; }\n\n.occupation-container .overflow {\n  background-color: red;\n  margin-left: -2px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/lea-front/src/app/shared/occupation/occupation-input.component.scss
// module id = ../../../../../src/app/shared/occupation/occupation-input.component.scss
// module chunks = main